import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

import { Card, EmptyState } from "../components/ui";

export function NotFoundPage() {
  return (
    <>
      <Card>
        <EmptyState
          icon={<Compass size={28} />}
          title="Page not found"
          body="That address does not match anything in the product."
          action={
            <Link
              to="/"
              className="text-sm font-medium text-slate-900 underline"
            >
              Back to the dashboard
            </Link>
          }
        />
      </Card>
    </>
  );
}